import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFileAlt, faFileSignature,  faUserTie, faFileContract, faFileInvoice, faClipboardList,
  faListAlt, faTasks, faHeartbeat, faClipboard, faFileArchive, faCalendarCheck, faCheckSquare, 
  faClipboardCheck, faFileExcel, faFile,  faChartBar
} from '@fortawesome/free-solid-svg-icons';
import './ThinkContract.css';
// import thinkhealthimage from '../../assets/pageimages/thinkhealthimage.webp';

function ThinkContractCompliance() {

  const LinkButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  const LinkNoButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  return (
    <MainLayout>
      <div className="mt-12 text-sm min-h-screen bg-gradient-to-r from-gray-300 via-gray-500 to-gray-600 flex flex-col items-center py-8">
      
        <p className="text-lg font-bold text-white text-center mb-4">Contract Labour (Regulation and Abolition) Act, 1970</p>
        <p className="text-xl font-bold text-white text-center mb-4">Compliance Forms & Registers</p>
        {/* <img
          src={thinkhealthimage}
          alt="ThinkHealth"
          className="w-1/3 h-auto max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-lg shadow-lg flex-wrap"
        /> */}

        <div className="flex-grow">
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-4 p-4 bg-purple-600 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <p className='text-xl text-yellow-200'>For Principal Employer</p>
            <LinkNoButton to="" icon={faFileAlt} label="Form I" /> {/* Icon for documents */}
            <LinkNoButton to="" icon={faClipboardCheck} label="Form V" /> {/* Icon for completed forms */}
            <LinkNoButton to="" icon={faFileSignature} label="Form VI A" /> {/* Icon for signing documents */}
            <LinkNoButton to="" icon={faUserTie} label="Register of Contractors" /> {/* Icon for business-related tasks */}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-4 p-4 bg-blue-600 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <p className='text-xl text-yellow-200'>For Contractor</p>
            <LinkNoButton to="" icon={faFileContract} label="Form IV" /> {/* Icon for contracts */}
            <LinkNoButton to="" icon={faFileInvoice} label="Form VI" /> {/* Icon for forms/documents */}
            <LinkNoButton to="" icon={faFile} label="Form VI B" /> {/* Simple document icon */}
            <LinkNoButton to="" icon={faFileAlt} label="Form XII" /> {/* Generic document icon */}
            <LinkNoButton to="" icon={faClipboardList} label="Form XIII" /> {/* Checklist icon */}
            <LinkNoButton to="" icon={faListAlt} label="Form XIV" /> {/* Icon for listing */}
            <LinkNoButton to="" icon={faTasks} label="Form XV" /> {/* Task icon */}
            <LinkNoButton to="" icon={faClipboard} label="Form XVI" /> {/* Icon for filling forms */}
            <LinkNoButton to="" icon={faFileArchive} label="Form XVII" /> {/* Archive-related */}
            <LinkNoButton to="" icon={faCalendarCheck} label="Form XIX" /> {/* Schedule/Calendar */}
            <LinkNoButton to="" icon={faCheckSquare} label="Form XX" /> {/* For completed tasks */}
            <LinkNoButton to="" icon={faClipboardCheck} label="Form XXI" /> {/* Checked form */}
            <LinkNoButton to="" icon={faFileExcel} label="Form XXII" /> {/* Spreadsheet-like document */}
            <LinkNoButton to="" icon={faFileAlt} label="Form XXIII" /> {/* Generic form */}
          </div>

          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-4 p-4 bg-green-500 rounded-lg shadow-lg transition-transform transform hover:scale-105 mx-4 mt-6">
            <p className='text-xl text-yellow-200'>Other Records & Registers</p>
            <LinkNoButton to="" icon={faFile} label="Form XXIV" /> {/* Simple form document */}
            <LinkNoButton to="" icon={faChartBar} label="Annual Return" /> {/* Icon for data/returns */}
            <LinkNoButton to="" icon={faHeartbeat} label="Health and Safety Registers" /> {/* Health-related */}
          </div>

        </div>
      </div>
    </MainLayout>
  );
}

export default ThinkContractCompliance;
